<template>
	<ManagingSection
		:isTable="true"
		:tableTitle="`참여자 리스트 (총 ${totalAttendeeCnt}명)`"
		:bodyScrollTable="true"
		class="participant-table"
	>
		<template slot="topBar">
			<div class="participant-table__top-bar">
				<div
					class="section__info__left"
					v-text="`검색결과 : ${searchAttendeeCnt}건`"
				/>
				<div class="section__info__right">
					<selector
						v-model="order"
						:optionList="orderList"
						nameKey="value"
						valueKey="id"
						class="section__info__items"
						@input="orderChange"
					/>
					<button
						type="button"
						class="btn-excel section__info__items"
						v-text="'엑셀 다운로드'"
						@click="downSpreadsheet"
					/>
				</div>
			</div>
		</template>
		<div slot="bodyScrollTable">
			<div class="body-scroll-table__thead-scroller">
				<table class="table-main participant-table__table">
					<thead>
						<tr>
							<th class="participant-table__table__col-1">
								<input
									v-model="allCheckModel"
									type="checkbox"
									class="participant-table__table__checkbox"
								/>
							</th>
							<th class="participant-table__table__col-29">
								참여일시
							</th>
							<th class="participant-table__table__col-3">
								회원번호
							</th>
							<th class="participant-table__table__col-4">
								닉네임
							</th>
							<th class="participant-table__table__col-56">
								성별
							</th>
							<th class="participant-table__table__col-56">
								나이
							</th>
							<th class="participant-table__table__col-7">
								피부타입
							</th>
							<th class="participant-table__table__col-grade">
								등급
							</th>
							<th class="participant-table__table__col-insta">
								인스타
							</th>
							<th
								class="participant-table__table__col-8 participant-table__table__col-def"
							>
								신청 정보 1
							</th>
							<th
								v-if="eventApplyData.length === 2"
								class="participant-table__table__col-8 participant-table__table__col-def"
							>
								신청 정보 2
							</th>
							<th class="participant-table__table__col-tel">
								휴대폰 번호
							</th>
							<th class="participant-table__table__col-29">
								가입일
							</th>
							<th class="participant-table__table__col-1011">
								리뷰 수
							</th>
							<th
								class="participant-table__table__th participant-table__table__col-1011"
							>
								이벤트 당첨 수
							</th>
							<th
								class="participant-table__table__beauty-profile"
							>
								뷰티 프로필
							</th>
							<th class="participant-table__table__col-12">
								최근 당첨 이력
							</th>
							<th
								class="participant-table__table__col-def participant-table__table__th"
							>
								당첨대기상태
							</th>
							<th class="participant-table__table__col-14">
								주의
							</th>
						</tr>
					</thead>
				</table>
			</div>
			<div
				class="body-scroll-table__tbody-scroller"
				@scroll="onListScroll"
			>
				<table class="table-main participant-table__table">
					<tbody>
						<tr
							v-for="item in slicedParsedAttendeeList"
							:key="item.idRegister"
							:class="[
								'participant-table__table__tr',
								{ visited: item.visited },
							]"
						>
							<td class="participant-table__table__col-1">
								<input
									v-model="checkedListModel"
									:value="item.idRegister"
									type="checkbox"
									class="participant-table__table__checkbox"
								/>
							</td>
							<td
								v-html="item.eventCandidate"
								class="participant-table__table__col-29 white-space__nowrap"
							/>
							<td class="participant-table__table__col-3">
								<a
									:href="`/register/register-info/${item.idRegister}`"
									class="link participant-table__table__link"
									v-text="item.idRegister"
									@click.prevent.stop="
										highlightBeforeLink(
											`/register/register-info/${item.idRegister}`,
											item.idRegister
										)
									"
								/>
							</td>
							<td class="participant-table__table__col-4">
								<a
									:href="`/register/register-info/${item.idRegister}`"
									:class="[
										'link participant-table__table__link',
										{ 'font-red': item.isWinner },
									]"
									v-text="item.nickName"
									@click.prevent.stop="
										highlightBeforeLink(
											`/register/register-info/${item.idRegister}`,
											item.idRegister
										)
									"
								/>
							</td>
							<td class="participant-table__table__col-56">
								{{ item.gender }}
							</td>
							<td class="participant-table__table__col-56">
								{{ item.age }}
							</td>
							<td class="participant-table__table__col-7">
								{{ item.skinType }}
							</td>
							<td class="participant-table__table__col-grade">
								<button
									type="button"
									class="btn small"
									@click="
										$store.commit('modal/toggleModal', {
											id: 'ReviewerGrade',
											params: item.idRegister,
										})
									"
									v-text="'리뷰어'"
								/>
							</td>
							<td class="participant-table__table__col-insta">
								<a
									v-if="
										item.isExternalAdvertising &&
                                        item.externalAdvertising &&
										item.externalAdvertising.instagramUrl
									"
									:href="
										item.externalAdvertising.instagramUrl
									"
									target="_blank"
									class="link insta-link"
									v-text="'링크'"
									@click.prevent.stop="
										highlightBeforeLink(
											item.externalAdvertising
												.instagramUrl,
											item.idRegister
										)
									"
								/>
							</td>
							<template v-if="item.answerList">
								<td
									v-for="(answer, idx) in item.answerList"
									:key="idx"
									class="participant-table__table__col-8 participant-table__table__col-def participant-table__table__td-no-padding"
								>
									<div
										v-if="
											answer.applyType === 3 &&
											Array.isArray(answer.values)
										"
										class="participant-table__table__img-box img-box"
									>
										<ImageExif
											:src="answer.values[0]"
											class="img-box__img"
											@click.native="
												viewOriginImg(item.idRegister)
											"
										/>
										<span
											v-if="answer.values.length > 1"
											class="img-box__text"
											v-text="
												`등 ${answer.values.length}장`
											"
										/>
									</div>
									<template v-else>{{
										answer.values.join() ||
										item.eventQuestionAnswer
									}}</template>
								</td>
							</template>
							<td v-else v-text="' - '" />
							<td class="participant-table__table__col-tel">
								<p class="participant-table__is-cert">
									<PhoneNumber :tel="item.userTel" />
									<span>
										<IsCertification
											:isCertification="
												item.isCertification
											"
										/>
									</span>
								</p>
							</td>
							<td
								class="participant-table__table__col-29 white-space__nowrap"
							>
								{{ item.createDate }}
							</td>
							<td class="participant-table__table__col-1011">
								<a
									:href="`/review/list?idRegister=${item.idRegister}`"
									class="link participant-table__table__link"
									v-text="item.reviewCount"
									@click.prevent.stop="
										highlightBeforeLink(
											`/review/list?idRegister=${item.idRegister}`,
											item.idRegister
										)
									"
								/>
							</td>
							<td class="participant-table__table__col-1011">
								<a
									:href="`/register/register-info/${item.idRegister}`"
									class="link participant-table__table__link"
									v-text="item.eventPrizeCnt"
									@click.prevent.stop="
										highlightBeforeLink(
											`/register/register-info/${item.idRegister}`,
											item.idRegister
										)
									"
								/>
							</td>
							<td
								class="participant-table__table__beauty-profile"
							>
								{{ item.beautyProfile }}
							</td>
							<td class="participant-table__table__col-12">
								{{ item.recentEventHistory }}
							</td>
							<td class="participant-table__table__col-def">
								<template v-if="item.otherEventInfo">
									<a
										:href="item.otherEventInfo.link"
										class="link"
										v-text="item.otherEventInfo.eventId"
										@click.prevent.stop="
											openBlank(item.otherEventInfo.link)
										"
									/>
									{{ item.otherEventInfo.subStr }}
								</template>
							</td>
							<td class="participant-table__table__col-14">
								<span
									v-if="item.blind"
									class="participant-table__table__warning__label--blind"
									v-text="item.blind"
								/>
								<span
									v-if="item.black"
									class="participant-table__table__warning__label--black"
									v-text="item.black"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</ManagingSection>
</template>
<script>
	import compact from 'lodash/compact';
	import uniq from 'lodash/uniq';
	import { mapState } from 'vuex';
	import { orderList, beautyProfileTypeList } from '@/constants.js';
	import Util from '@/util.js';
	import { eventUserAnswerList } from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ImageExif from '@/components/ImageExif';
	import PhoneNumber from '@/components/Atoms/PhoneNumber';
	import IsCertification from '@/components/Atoms/IsCertification';
	import Selector from '@/components/Selector.vue';

	export default {
		name: 'EventWinnerPickAttendeeList',
		components: {
			ManagingSection,
			ImageExif,
			PhoneNumber,
			IsCertification,
			Selector,
		},
		props: {
			eventApplyData: {
				type: Array,
				default: () => [],
			},
			lastListReqUrl: {
				type: String,
				default: '',
			},
			totalAttendeeCnt: {
				type: Number,
				default: 0,
			},
			searchAttendeeCnt: {
				type: Number,
				default: 0,
			},
			attendeeList: {
				type: Array,
				default: () => [],
			},
			winnerMappedPdtList: {
				type: Array,
				default: () => [],
			},
			idEvent: {
				type: String,
				default: null,
			},
			eventTitle: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				orderList,
				order: orderList[0].id,
				allCheck: false,
				visitedIdList: [],
				offset: 0,
				limit: 100,
				checkedList: [],
			};
		},
		computed: {
			...mapState('env', ['IMAGE_STORAGE_PATH']),
			parsedAttendeeList() {
				const winnerMappedPdtList = this.winnerMappedPdtList;

				return this.attendeeList.map(item => ({
					...item,
					isWinner: winnerMappedPdtList.length
						? uniq(
								winnerMappedPdtList
									.map(item => item.candidates)
									.flat()
									.map(item => item.idRegister)
							).some(winnerId => winnerId === item.idRegister)
						: false,
					visited: this.visitedIdList.some(
						visitedId => visitedId === item.idRegister
					),
					answerList:
						this.eventApplyData.length && item.eventQuestionAnswer
							? eventUserAnswerList(
									item.eventQuestionAnswer,
									this.eventApplyData
								)
							: null,
				}));
			},
			sliceLength() {
				return this.offset + this.limit;
			},
			slicedParsedAttendeeList() {
				return this.parsedAttendeeList.slice(0, this.sliceLength);
			},
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(nv) {
					this.allCheck = nv;
					this.checkedList = nv
						? this.attendeeList.map(item => item.idRegister)
						: [];
				},
			},
			checkedListModel: {
				get() {
					return this.checkedList;
				},
				set(nv) {
					this.checkedList = nv;
					this.allCheck = this.attendeeList.length === nv.length;
				},
			},
		},
		watch: {
			checkedList(v) {
				this.$emit('checkedList', v);
			},
		},
		methods: {
			initOrder() {
				this.order = orderList[0].id;
			},
			orderChange() {
				this.$parent.searching();
			},
			groupByBeautyProfileType(idList) {
				return beautyProfileTypeList.map(item =>
					idList
						? compact(
								idList.split(',').map(id => item.idMap[id])
							).join(' / ')
						: ''
				);
			},
			downSpreadsheet() {
				const rows = this.parsedAttendeeList.map(item => {
					const eventAnswerValue = item?.answerList?.map(
						item =>
							item.values.join() ||
							item.eventQuestionAnswer ||
							'-'
					);

					return [
						item.eventCandidate.replace('<br>', ' '),
						item.idRegister,
						item.nickName,
						item.gender,
						item.age,
						item.skinType,
						item.externalAdvertising?.instagramUrl,
						this.eventApplyData.length > 0 && item.answerList
							? eventAnswerValue[0]
							: '-',
						this.eventApplyData.length > 0 && item.answerList
							? eventAnswerValue[1]
							: '-',
						item.createDate,
						item.reviewCount,
						...this.groupByBeautyProfileType(
							item.beautyProfileIdList
						),
						item.eventPrizeCnt,
						item.recentEventHistory,
						item.otherEventInfo
							? compact([
									item.otherEventInfo.eventId,
									item.otherEventInfo.subStr,
								]).join(' ')
							: '',
						compact([item.blind, item.black]).join(' '),
					];
				});

				Util.getCsv(
					[rows],
					[this.eventTitle],
					[
						[
							'참여일시',
							'회원번호',
							'닉네임',
							'성별',
							'나이',
							'피부타입',
							'인스타그램',
							'신청정보1',
							'신청정보2',
							'가입일',
							'리뷰 수',
							...beautyProfileTypeList.map(({ type }) => type),
							'이벤트 당첨 수',
							'최근 당첨이력',
							'당첨대기상태',
							'주의',
						],
					],
					`이벤트참여자리스트_${this.eventTitle}_${new Date().getTime()}`,
					this.lastListReqUrl
				);
			},
			openBlank(link) {
				window.open(link, '_blank');
			},
			highlightBeforeLink(link, id) {
				const hasSame = this.visitedIdList.some(item => item === id);
				if (!hasSame) this.visitedIdList = [...this.visitedIdList, id];
				this.openBlank(link);
			},
			async viewOriginImg(idRegister) {
				try {
					const url = `/api/event/candidate/${this.idEvent}/${idRegister}/images`;
					const { data } = await this.$axiosAdmin2.get(url);
					await Util.popupImages(
						data.map(item => `${this.IMAGE_STORAGE_PATH}${item}`),
						500,
						true
					);
				} catch (err) {
					console.error(err);
					alert(
						'등록된 이미지 불러오기를 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			onListScroll(e) {
				if (
					this.sliceLength < this.parsedAttendeeList.length &&
					e.target.scrollTop / e.target.scrollHeight > 0.9
				) {
					this.offset += this.limit;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	section {
		.no-horizontal-padding {
			padding-left: 0;
			padding-right: 0;
		}

		.white-space-normal {
			white-space: normal;
			word-break: break-all;
		}

		.participant-table {
			&__top-bar {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.body-scroll-table__thead-scroller,
			.body-scroll-table__tbody-scroller {
				min-width: 1200px;
			}

			.body-scroll-table__tbody-scroller {
				max-height: 360px;
			}

			.participant-table__table {
				min-width: 1024px;

				th {
					white-space: nowrap;
				}
			}

			.participant-table__table__th {
				padding: 0 8px;
			}

			.participant-table__table__td-no-padding {
				padding: 0;
			}

			.participant-table__table__col-1 {
				@extend .no-horizontal-padding;
				width: 24px;
			}

			.participant-table__table__col-29 {
				@extend .no-horizontal-padding;
				width: 86px;
			}

			.participant-table__table__col-tel {
				@extend .no-horizontal-padding;
				width: 88px;
			}

			.participant-table__table__col-grade {
				width: 78px;
			}

			.participant-table__table__col-insta {
				width: 52px;
			}

			.participant-table__table__col-3 {
				@extend .no-horizontal-padding;
				width: 58px;
			}

			.participant-table__table__col-4 {
				width: 76px;
			}

			.participant-table__table__col-56 {
				@extend .no-horizontal-padding;
				width: 40px;
			}

			.participant-table__table__col-7 {
				@extend .no-horizontal-padding;
				width: 60px;
			}

			.participant-table__table__col-8 {
				position: relative;
				min-width: 78px;
			}

			.participant-table__table__col-1011 {
				@extend .no-horizontal-padding;
				width: 86px;
			}

			.participant-table__table__beauty-profile {
				width: auto;
			}

			.participant-table__table__col-12 {
				@extend .white-space-normal;
				width: 212px;
			}

			.participant-table__table__col-14 {
				width: 68px;
			}

			.participant-table__table__col-def {
				@extend .white-space-normal;
				width: auto;
			}

			.participant-table__is-cert {
				display: flex;
				flex-direction: column;
			}

			.participant-table__table__tr.visited {
				background: #fffacd;
			}

			.participant-table__table__checkbox {
				cursor: pointer;
				display: block;
				margin: 0 auto;
			}

			.participant-table__table__link {
				@extend .white-space-normal;
			}

			.img-box {
				display: grid;
				grid-template-columns: 2fr 1.5fr;
				width: 100%;
				height: 100%;

				& > div {
					display: grid;
					place-content: center;
				}
			}

			.img-box__img {
				cursor: pointer;
				max-height: 64px;
				place-content: center;
			}

			.img-box__text {
				padding: 0 4px;
			}

			.participant-table__table__warning__label {
				display: block;
				width: auto;
				height: 24px;
				margin: 0 auto;
				padding: 0 8px;
				border-radius: 12px;
				line-height: 24px;
				text-align: center;
				color: white;
				font-weight: 700;

				& + .participant-table__table__warning__label {
					margin-top: 4px;
				}
			}

			.participant-table__table__warning__label--blind {
				@extend .participant-table__table__warning__label;
				background: $orange;
			}

			.participant-table__table__warning__label--black {
				@extend .participant-table__table__warning__label;
				background: $btn-red;
			}

			.insta-link {
				word-break: break-all;
			}
		}
	}
</style>
